import { $httpRootApi } from '@core/http-client';
import { getQueriesAsSearch } from '@shared/utils/common';

import { UserNotificationHistoryPayload, UserNotificationHistoryResponse, UserNotificationsIndexResponse } from './notificationsApi.types';

export const notificationsQueries = {
  history: async (payload: UserNotificationHistoryPayload) =>
    $httpRootApi.get<UserNotificationHistoryResponse>(`/user/notifications/history${getQueriesAsSearch(payload.query)}`),
  index: async () => $httpRootApi.get<UserNotificationsIndexResponse>('/user/notifications'),
};
